/**
 * カート画面の「お届け希望日」「のし種類」「名入れ」編集・保存
 * main-cart-items.liquid 内の .cart-delivery-noshi-editor を対象とする
 *
 * 保存後は main-cart-items セクションをAjaxで再取得し、
 * #main-cart-items の中身を差し替える（Dawn標準のセクションレンダリング方式）。
 * イベントはdocumentへの委任リスナーのため、再描画後も再バインド不要。
 */
(function () {
  function getEditor(el) {
    return el.closest('.cart-delivery-noshi-editor');
  }

  function toggleNoshiNameField(editor) {
    const select = editor.querySelector('.cart-noshi-select');
    const nameField = editor.querySelector('.cart-noshi-name-field');
    if (!select || !nameField) return;
    const noneValue = editor.dataset.noshiNoneValue;
    nameField.hidden = select.value === noneValue;
  }

  function getQuantityForLine(line) {
    const qtyInput = document.getElementById(`Quantity-${line}`);
    return qtyInput ? parseInt(qtyInput.value, 10) : 1;
  }

  function setSaving(editor, saving) {
    const button = editor.querySelector('.cart-noshi-save');
    if (button) button.disabled = saving;
  }

  function showStatus(editor, message) {
    const status = editor.querySelector('.cart-noshi-save-status');
    if (!status) return;
    status.textContent = message;
    status.hidden = false;
    setTimeout(() => {
      status.hidden = true;
    }, 2500);
  }

  function buildProperties(editor) {
    const deliveryLabel = editor.dataset.deliveryLabel;
    const noshiLabel = editor.dataset.noshiLabel;
    const noshiNameLabel = editor.dataset.noshiNameLabel;
    const noneValue = editor.dataset.noshiNoneValue;

    const properties = {};

    const dateInput = editor.querySelector('.cart-delivery-date');
    if (dateInput) {
      properties[deliveryLabel] = dateInput.value;
    }

    const noshiSelect = editor.querySelector('.cart-noshi-select');
    const noshiValue = noshiSelect ? noshiSelect.value : noneValue;
    properties[noshiLabel] = noshiValue;

    const noshiNameInput = editor.querySelector('.cart-noshi-name');
    properties[noshiNameLabel] = noshiValue === noneValue ? '' : (noshiNameInput ? noshiNameInput.value : '');

    return properties;
  }

  function refreshCartItemsSection() {
    const url = `${window.location.pathname}?sections=main-cart-items`;
    return fetch(url)
      .then((res) => res.json())
      .then((sections) => {
        const html = new DOMParser().parseFromString(sections['main-cart-items'], 'text/html');
        const newContent = html.getElementById('main-cart-items');
        const oldContent = document.getElementById('main-cart-items');
        if (newContent && oldContent) {
          oldContent.innerHTML = newContent.innerHTML;
        }
        document.dispatchEvent(new CustomEvent('cart:delivery-noshi-updated'));
      });
  }

  function saveEditor(editor) {
    const line = parseInt(editor.dataset.line, 10);
    const properties = buildProperties(editor);
    const quantity = getQuantityForLine(line);

    setSaving(editor, true);

    fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity, properties }),
    })
      .then((res) => {
        if (!res.ok) throw new Error(`cart/change.js failed: ${res.status}`);
        return res.json();
      })
      .then(() => refreshCartItemsSection())
      .then(() => {
        // 再描画後の該当行にステータスを表示する
        const refreshedEditor = document.querySelector(
          `.cart-delivery-noshi-editor[data-line="${line}"]`
        );
        if (refreshedEditor) showStatus(refreshedEditor, '保存しました');
      })
      .catch((err) => {
        console.error('お届け日・のしの保存に失敗しました:', err);
        showStatus(editor, '保存に失敗しました');
      })
      .finally(() => {
        setSaving(editor, false);
      });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.cart-noshi-save');
    if (!button) return;
    const editor = getEditor(button);
    if (editor) saveEditor(editor);
  });

  document.addEventListener('change', (event) => {
    if (event.target.classList.contains('cart-noshi-select')) {
      const editor = getEditor(event.target);
      if (editor) toggleNoshiNameField(editor);
    }
  });
})();
